import React from 'react';
import { NavLink, NavLinkProps } from 'react-router-dom';

import { getFilteredQueryParams } from '@neo.tax/shared/utils';

interface NavLinkToProps extends NavLinkProps {
  disabled?: boolean;
  hash?: string;
}

export const NavLinkTo = React.forwardRef(function NavLinkTo(
  { children, className, disabled, hash, to, ...rest }: NavLinkToProps,
  ref: React.ForwardedRef<HTMLAnchorElement>,
) {
  if (disabled) {
    const renderedChildren =
      typeof children === 'function'
        ? children({ isActive: false, isPending: false, isTransitioning: false })
        : children;
    return (
      <a
        aria-disabled
        ref={ref}
        className={
          typeof className === 'function'
            ? className({ isActive: false, isPending: false, isTransitioning: false })
            : className
        }
      >
        {renderedChildren}
      </a>
    );
  }
  const search = `?${getFilteredQueryParams()}`;
  const appendHash = hash ? '#' + hash : '';
  return (
    <NavLink to={to + search + appendHash} {...rest} ref={ref} className={className}>
      {children}
    </NavLink>
  );
});
